<template>
  <div>
    <div class="br-pagetitle d-flex justify-content-between align-items-center">
      <div class="d-flex align-items-center">
        <i class="icon ion-images"></i>
        <div class="mg-l-20">
          <h4>{{$t('product.商品相册详情')}}
          </h4>
        </div>
      </div>
      <div class="tx-right d-flex align-items-center">
      	 <button v-if="!$root.$children[0].userInfo.rootUrl"
          class=" mg-r-10 btn btn-primary"
          type="button"
           @click="shareAlbum"
        >{{$t('product.分享相册')}}</button>
      </div>
    </div>
    <div class="d-flex align-items-center justify-content-start pd-x-20 pd-sm-x-30">
      <div class="clear-key">
        <a
          v-show="keyStatus"
          href="javascript:;"
          class=" mg-r-15"
          @click="clearKey('status')"
        >
          {{$t('product.状态：')}}
          <span class="mg-r-10">{{$t($dict.imgsStatus[keyStatus])}}</span>
          <i class="fa fa-close"></i>
        </a>
      </div>
      <div class="clear-key">
        <a
          v-show="keyType"
          href="javascript:;"
          class=" mg-r-15"
          @click="clearKey('type')"
        >
          {{$t('product.类型：')}}
          <span class="mg-r-10">{{$t($dict.imgsType[keyType])}}</span>
          <i class="fa fa-close"></i>
        </a>
      </div>
      <div class="clear-key">
        <a
          v-show="keyName"
          href="javascript:;"
          class=" mg-r-15"
          @click="clearKey('name')"
        >
         {{$t('product.图片名称：')}}
          <span class="mg-r-10">{{keyName}}</span>
          <i class="fa fa-close"></i>
        </a>
      </div>
      <div class="clear-key">
        <a
          v-show="keyUrl"
          href="javascript:;"
          class=" mg-r-15"
          @click="clearKey('url')"
        >
         {{$t('product.图片URL：')}}
          <span class="mg-r-10">{{keyUrl}}</span>
          <i class="fa fa-close"></i>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["keyName", "keyStatus","keyType", "keyClickType","keyName","keyUrl"],
  methods: {
    clearKey(type){
      this.$emit('clearKey', type)
    },
    shareAlbum(){
    	this.$emit('shareAlbum')
    },
  }
};
</script>